import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 0 0;
  width: 100%;
  gap: 32px;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ContentButton = styled.div`
  display: flex;
  gap: 12px;
`;

export const Separator = styled.hr`
  margin: 16px 0px;
  border: none;
  height: 2px;
  background: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
`;

export const ContentInputs = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 20px;
  gap: 12px;
`;
